import BaseSearchOptions from './_baseSearchOptions'

export default BaseSearchOptions()


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/persistent/modules/mxcategoryItems.js